import type { PermissionCode } from '@magimp/shared';

// WHY: rbac.groups in the locale tree has one entry per PermissionCode resource
// prefix (e.g. 'users', 'requests') plus the synthetic 'transitions' bucket.
// Constraining `groupId` to that union lets typed `t()` validate the resulting
// `rbac:groups.<x>` key directly.
export type RbacGroupId =
  | (PermissionCode extends `${infer R}.${string}` ? R : never)
  | 'transitions';

export function permissionLabelKey(code: PermissionCode): `rbac:permissions.${PermissionCode}` {
  return `rbac:permissions.${code}`;
}

export function permissionGroupKey(groupId: RbacGroupId): `rbac:groups.${RbacGroupId}` {
  return `rbac:groups.${groupId}`;
}
